module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAOVJREFUOI3dksFxgzAQRd8qLgJuKUEY361WUgmikpRiuGc8KiG3uAqvD4KMZBSMb578C8No9fb/1cK/1dvaobUHV9X1Z1XV75fLz7hWK6XLiHaAAwZUh1gpHlUPEMK5/xO0BEgfwteQN9l3iHgAVH0KlOSweLkced+lLkM49wbMOFl2cD1ae3CPQGBGRKJzzJhFy6wXZpFH12/UfKTul8NuWp1Bv9DYHVR6uB7vm5TzN63eu0zjxv9pRol2q9QtnSeZLUWZ5pgPQareNu2p9HpTJDe/VMYv0RfLGb+LJXxK2/bqFXUDcvFtJJvuOh8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliXuewei.png
// module id = KSOY
// module chunks = 1